export const RGSquareBracket = /\[([^\]]+)\]/g
export const RGSquareBracketReplace = /\[(.[^\]]*)\]/gm
export const RGHexColor = /#([a-f0-9]{6}|[a-f0-9]{3})/g
export const RGEmail =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g
